


















import { Vue, Component } from "vue-property-decorator"

const AppProps = Vue.extend({
	props: {
		recipe: {
			type: Object,
			required: true
		}
	}
})

@Component({})
export default class RecipeCard extends AppProps {
	handleCardClick() {
		this.$router.push({ path: "recipes/" + this.recipe.name })
	}

	getImage() {
		return this.recipe.image === "NaN" || !this.recipe.image ? require("@/assets/recipes/recipe_default.jpg") : require("@/assets/recipes/" + this.recipe.image)
	}
}
